<template>
	<div
		v-if="showElement"
		:class="['flash-sale', flashSaleClasses]"
	>
		<template v-if="showProductAmount">
			<progress-bar
				v-if="productPrice.flashSale && productPrice.maxAmountForPrice"
				:value="salesProgress"
				:gradientColors="['#D50855', '#FED900']"
			/>
			<span class="product-amount">
				{{ formattedProductAmount }}&nbsp;
			</span>
		</template>
		<span
			v-if="productPrice.flashSale || daysUntilEndOfSale <= 3"
			class="end-time"
		>
			{{ saleEndPrefix }}
			<countdown-timer
				v-if="showCountDown"
				:targetTime="formattedCountdown"
				compactCountdown
			/>
			<template v-else>
				{{ formattedSaleEnds }}
			</template>
		</span>
	</div>
</template>

<script>
export default {
	props: {
		productPrice: {
			type: Object,
			required: true,
		},
		compact: {
			type: Boolean,
			default: false,
		},
		showWhenSaleOver: {
			type: Boolean,
			default: false,
		},
		overBookingProtection: {
			type: Boolean,
			default: false,
		},
	},
	data () {
		return {
			showCountDown: false,
		};
	},
	computed: {
		saleEndPrefix () {
			let saleEnd = '';
			if ((this.compact && this.productPrice.maxAmountForPrice) || this.salesProgress >= 1) {
				saleEnd = '';
			} else if (this.daysUntilEndOfSale > 3) {
				saleEnd = 'Slutar';
			} else if (this.showCountDown || this.daysUntilEndOfSale > 0) {
				saleEnd = 'Slutar om';
			}
			return saleEnd;
		},
		formattedSaleEnds () {
			const options = { year: 'numeric', month: 'numeric', day: 'numeric' };
			let saleEnd = '';

			if (this.salesProgress >= 1 || this.productPrice.amountLeft === 0) {
				saleEnd = 'Dealen är slut';
			} else if (this.daysUntilEndOfSale > 3) {
				this.setShowCountDown(false);
				saleEnd = this.endOfSale.toLocaleDateString('sv-SE', options);
			} else if (this.daysUntilEndOfSale > 0) {
				this.setShowCountDown(false);
				const dayOrDays = this.daysUntilEndOfSale > 1 ? 'dagar': 'dag';
				saleEnd = this.daysUntilEndOfSale + ' ' + dayOrDays;
			} else {
				this.setShowCountDown(true);
			}
			return saleEnd;
		},
		formattedProductAmount () {
			let amount = 0;

			if (this.saleOver) {
				return this.productPrice.maxAmountForPrice  + '/' + this.productPrice.maxAmountForPrice + ' sålda';
			} else if (! this.productPrice.flashSale) {
				amount = this.productPrice.amountLeft || 0;
				const infoText = this.overBookingProtection ? ' st kvar tills fullbokad.' : ' st kvar till kampanjpris.'
				return amount + infoText;
			} else {
				amount = Math.min((this.productPrice.soldAmount || 0), this.productPrice.maxAmountForPrice);
				return amount + '/' + this.productPrice.maxAmountForPrice + ' sålda';
			}
		},
		formattedCountdown () {
			if (this.saleOver) {
				return new Date();
			} else {
				return this.endOfSale;
			}
		},
		salesProgress () {
			if (this.saleOver) {
				return 1;
			} else if (this.productPrice.maxAmountForPrice && this.productPrice.soldAmount) {
				return this.productPrice.soldAmount / this.productPrice.maxAmountForPrice;
			} else {
				return 0;
			}
		},
		saleOver () {
			const today = new Date();

			return this.productPrice.nearlyOver && today >= this.endOfSale;
		},
		daysUntilEndOfSale () {
			const today = new Date();
			return Math.floor((this.endOfSale - today) / (1000 * 60 * 60 * 24));
		},
		showElement () {
			if (this.showWhenSaleOver) {
				return true;
			} else if (this.productPrice.flashSale) {
				return ! (this.salesProgress >= 1);
			} else if (this.productPrice.amountLeft) {
				return ! this.saleOver && (this.productPrice.amountLeft <= 30 || this.daysUntilEndOfSale <= 3);
			} else {
				return ! this.saleOver && this.daysUntilEndOfSale < 3;
			}
		},
		showProductAmount () {
			return this.productPrice.maxAmountForPrice || (this.productPrice.amountLeft && this.productPrice.amountLeft <= 30);
		},
		endOfSale () {
			return new Date(this.productPrice.endAt);
		},
		flashSaleClasses () {
			return [
				{
					'sales-progress': this.productPrice.flashSale && this.productPrice.maxAmountForPrice,
					'compact': this.compact,
					'sale-over': this.salesProgress >= 1,
					'pre-book': this.overBookingProtection,
				},
			];
		},
	},
	methods: {
		setShowCountDown (value) {
			this.showCountDown = value;
		},
	},
};
</script>
